import AdminFinanceOverviewPage from '../../../components/admin/finance/AdminFinanceOverviewPage'

export default function SettingsFinance() {
  return <AdminFinanceOverviewPage />
}
